import type { FC } from 'react'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import { AgentRegistrationFields } from '@/components/composed/financing/AgentRegistrationFields'
import { Button } from '@/components/ui'
import { useData } from '@/logic/data'
import { getLegalDocumentUrl } from '@/logic/legalDocuments/helpers'
import { messages } from '@/pages/JournalPublication/components/PublicationText/components/PublicationFinancingWidget/components/PublicationFinancingWidgetCollapsingAgentRegistration/messages'
import type { IAgentRegistrationRequestFormValues } from '@/types/IAgentRegistrationRequestFormValues'
import type { TLegalDocuments } from '@/types/legalDocuments'
import { ELegalDocumentType } from '@/types/legalDocuments'
import { formatLocalizedString } from '@/utils/formatUtils'
import type { IPublicationFinancingWidgetCollapsingAgentRegistrationBaseFormProps } from './types'
import './styles.scss'

export const PublicationFinancingWidgetCollapsingAgentRegistrationBaseForm: FC<
  IPublicationFinancingWidgetCollapsingAgentRegistrationBaseFormProps
> = props => {
  const { onSubmit } = props

  const { trigger } = useFormContext<IAgentRegistrationRequestFormValues>()
  const { data: legalDocuments = [] } = useData<TLegalDocuments>('legalDocuments')
  const agreementLink = getLegalDocumentUrl(legalDocuments, ELegalDocumentType.registrationPolicy)

  const handleSubmit = async () => {
    const isValid = await trigger()

    if (isValid) onSubmit()
  }

  return (
    <div className="publicationFinancingWidgetCollapsingAgentRegistrationBaseForm">
      <h3>{messages.title}</h3>

      <div className="publicationFinancingWidgetCollapsingAgentRegistrationBaseForm__wrapper">
        <div className="publicationFinancingWidgetCollapsingAgentRegistrationBaseForm__text">{messages.description}</div>
        <div className="publicationFinancingWidgetCollapsingAgentRegistrationBaseForm__form">
          <form onSubmit={handleSubmit}>
            <AgentRegistrationFields
              className="publicationFinancingWidgetCollapsingAgentRegistrationBaseForm__fields"
              classNameRegionFiled="publicationFinancingWidgetCollapsingAgentRegistrationBaseForm__regionsFiled"
            />

            <div className="publicationFinancingWidgetCollapsingAgentRegistrationBaseForm__agreements">
              {formatLocalizedString(messages.form.agreements.text, {
                link: (
                  <CommonLink className="underline_green color_green" url={agreementLink} shouldOpenInNewWindow>
                    <FormattedMessage id={messages.form.agreements.link} />
                  </CommonLink>
                ),
              })}
            </div>

            <div className="publicationFinancingWidgetCollapsingAgentRegistrationBaseForm__actions">
              <Button onClick={handleSubmit} modifiers={['green', 'full-width-mobile']}>
                {messages.form.actions.sent}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
